var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4167 54.25V7.58333C48.4167 6.03624 47.8021 4.55251 46.7081 3.45854C45.6142 2.36458 44.1304 1.75 42.5833 1.75H13.4167C11.8696 1.75 10.3858 2.36458 9.29188 3.45854C8.19791 4.55251 7.58333 6.03624 7.58333 7.58333V54.25M48.4167 54.25H7.58333M48.4167 54.25H54.25M48.4167 54.25H33.8333M7.58333 54.25H1.75M7.58333 54.25H22.1667M33.8333 54.25V39.6667C33.8333 38.8931 33.526 38.1513 32.9791 37.6043C32.4321 37.0573 31.6902 36.75 30.9167 36.75H25.0833C24.3098 36.75 23.5679 37.0573 23.0209 37.6043C22.474 38.1513 22.1667 38.8931 22.1667 39.6667V54.25M33.8333 54.25H22.1667M19.25 13.4167H22.1667M19.25 25.0833H22.1667M33.8333 13.4167H36.75M33.8333 25.0833H36.75",
    stroke: "#9CA3AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarNone);
export default __webpack_public_path__ + "static/media/avatar-none.615285246dfc3ededf8026425b649c63.svg";
export { ForwardRef as ReactComponent };